var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-button",class:_vm.variantButton,style:({ width: _vm.width })},[_c('button',{style:({
      height: _vm.customHeight ? _vm.customHeight : _vm.height,
      backgroundColor: _vm.backgroundColor,
      fontSize: _vm.customFontSize ? _vm.customFontSize : _vm.fontSize,
      borderRadius: _vm.borderRadius ? _vm.borderRadius : _vm.rounded ? '10px' : '0px',
      maxWidth: _vm.maxWidth,
      color: _vm.textColor,
      fontWeight: _vm.fontWeight,
    }),attrs:{"type":_vm.type,"form":_vm.form,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default"),_vm._v("\n    "+_vm._s(_vm.btnText)+"\n  ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }